// extracted by mini-css-extract-plugin
export var deliveryRow = "_rs-a";
export var fixedHeight = "_rs-4";
export var freightLogo = "_rs-9";
export var fullWidth = "_rs-3";
export var priceColumn = "_rs-5";
export var radioSelected = "_rs-7";
export var radioUnselected = "_rs-6";
export var selectedOption = "_rs-2";
export var selectedOptionContainer = "_rs-1";
export var selection = "_rs-0";
export var tallSkeletonText = "_rs-8";